import { tableWidth } from '../pro-report-email-styles';
import {
  ProReportEmailFullWidthInfoRow,
  ProReportEmailFullWidthTableHeader,
} from './pro-report-email-common-components';

function ProReportEmailNoDataPlaceHolder({
  header,
  subHeading,
  content,
}: {
  header: string;
  subHeading: string;
  content: string;
}) {
  return (
    <table
      width={tableWidth}
      cellPadding={0}
      cellSpacing={0}
      style={{ borderCollapse: 'collapse', margin: 0, padding: 0 }}
      role="presentation"
    >
      <ProReportEmailFullWidthTableHeader headerText={header} />
      <tbody>
        <ProReportEmailFullWidthInfoRow
          heading={subHeading}
          content={content}
        />
      </tbody>
    </table>
  );
}

export default ProReportEmailNoDataPlaceHolder;
